// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"257":"7ea546a7","315":"c1c4a38b","923":"5f0028ce"}[chunkId] + ".chunk.js";
};